import React from 'react';

import { CheckOutlined } from '@ant-design/icons';
import { Empty, List } from 'antd';
import classNames from 'classnames';

import { EMPTY_MESSAGES } from '@/shared/lib/constants';
import { formatTierName } from '@/shared/lib/format';
import type { TierEditHook } from '@/shared/types/editHooks';

import styles from './TierEditPopover.module.css';

export type TierEditPopoverProps = {
  tierEdit: TierEditHook;
  currentTierFQN?: string;
};

export const TierEditPopover: React.FC<TierEditPopoverProps> = ({ tierEdit, currentTierFQN }) => {
  const { availableTiers, selectedTierFQN, handleUpdate } = tierEdit;

  return (
    <div className={styles.popover}>
      <div className={styles.listContainer}>
        {availableTiers.length > 0 ? (
          <List
            dataSource={availableTiers}
            renderItem={(tier) => {
              const isSelected = selectedTierFQN === tier.fullyQualifiedName;
              const isExisting = currentTierFQN === tier.fullyQualifiedName;

              return (
                <List.Item
                  onClick={() => handleUpdate(tier.fullyQualifiedName)}
                  className={classNames('listItem', {
                    selected: isSelected && !isExisting,
                    existing: isSelected && isExisting,
                  })}>
                  <div className={styles.listItemContent}>
                    <div className={styles.tierLabelWrapper}>
                      <span className={styles.tierName}>{formatTierName(tier.name)}</span>
                    </div>
                  </div>
                  {isSelected && isExisting && <CheckOutlined />}
                </List.Item>
              );
            }}
          />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_MESSAGES.NO_TIER} />
        )}
      </div>
    </div>
  );
};
